import { DataTable } from '../../../design-system/data-table/data-table';
import { OAuthProviderConnection } from '../types/types';
import { oauthConnectionTableColumnsDefinition, STATUS_COLUMN_ID } from './oauth-connection-table-column-definition';

type OAuthConnectionTableProps = {
  connections: OAuthProviderConnection[];
  onReviewInvoice: (id: string) => void;
};

export const OAuthConnectionTable = ({ connections, onReviewInvoice }: OAuthConnectionTableProps) => {
  return (
    <DataTable
      columns={oauthConnectionTableColumnsDefinition}
      data={connections}
      initialSorting={[{ id: STATUS_COLUMN_ID, desc: false }]}
      meta={{
        onReviewInvoice,
      }}
    />
  );
};
